import { useRef } from 'react';

export const useLatestRef = <T>(values: T) => {
  const ref = useRef(values);
  ref.current = values;
  return ref;
};
